import React from 'react'
import Stack from 'react-bootstrap/Stack'
import useGetSiteMetadata from '../hooks/useGetSiteMetadata'

export default function Socials({ className }) {
    const { socials } = useGetSiteMetadata()

    return (
        <Stack direction='horizontal' gap={4} className={className}>
            {socials.map(({ name, url, iconRelativePath }) => {
                return (
                    <a key={name} href={url} target='_blank' rel='noreferrer'>
                        <img src={iconRelativePath} alt={name} height={24} width={24} />
                    </a>
                )
            })}
        </Stack>
    )
}
